import React, { useState } from 'react';

import EventTracking from 'lib/EventTracking';

import ErrorReporter from 'app/components/ErrorReporter';
import FormElement from 'components/FormElement';
import Select from 'components/Select';
import Text from 'components/Text';

import CoachPauseReasonsContainer from 'coaching/containers/CoachPauseReasonsContainer';
import { PauseReason } from 'globalTypes';

type Props = {
  changeState: (reason: PauseReason) => void;
  eventPrefix?: string;
  initialReason?: PauseReason;
};

export const CoachPauseReasonsSelect = ({ changeState, eventPrefix, initialReason }: Props) => {
  const [selectedReason, setSelectedReason] = useState<PauseReason | undefined>(initialReason);
  const trackKey = (key: string) => {
    eventPrefix && EventTracking.trackKey(`${eventPrefix}.${key}`);
  };

  React.useEffect(() => {
    trackKey('view');
  });

  return (
    <CoachPauseReasonsContainer>
      {({ pauseReasons, error }) => {
        if (error || !pauseReasons) {
          return <ErrorReporter error={error ?? 'Could not load coach pause reasons'} />;
        }
        return (
          <FormElement
            data-test="pause-reason-dropdown"
            label={
              <>
                <Text>Reason for pause</Text>
                <Text element="div" color="graphite" weight="normal">
                  Select one that fits best
                </Text>
              </>
            }
            element={Select}
            elementProps={{
              options: pauseReasons.map(reason => ({
                label: reason.uiLabel,
                value: reason.slug,
              })),
              value: selectedReason,
              placeholder: 'Select a reason',
            }}
            onValidChange={value => {
              setSelectedReason(value);
              changeState(value);
            }}
          />
        );
      }}
    </CoachPauseReasonsContainer>
  );
};
